import Dispatcher from '../dispatcher/CentricDispatcher.react.js';
import { ReduceStore } from 'flux/utils';
import { ActionTypes } from '../constants/CentricConstants';


class AuthMethodStore extends ReduceStore {

    getInitialState() {
        return [];
    }

    getAll() {
        return this.getState();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.USER_AUTH_METHOD_LIST_REQUEST:
                return [];
            case ActionTypes.USER_AUTH_METHOD_LIST_SUCCESS:
                return action.data;
            default:
                return state;
        }
    }
}

export default new AuthMethodStore(Dispatcher);
